import superjson from 'superjson'

// How queries fetched during server rendering travel to the browser. Response schemas coerce
// date fields into `Date`s, which plain JSON would turn into strings; superjson keeps them.
export const queryHydration = {
  transformer: superjson,
}
